import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Copy } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import InlineTextAndTooltip from '../../utils/components/InlineTextTooltip';
import PriceComponent from '../PriceComponent';
import SpecialOffersTooltipAnchor from './shared/SpecialOffersTooltipAnchor';
import themeStyles from './SpecialOfferCard.styles';
const SellingPriceContainer = themeStyles.apply(Box, 'SellingPriceContainer');
const SellingPriceCopy = themeStyles.apply(Copy, 'SellingPriceCopy');
const PriceWrapper = themeStyles.apply(Box, 'PriceWrapper');
const StyledTooltip = themeStyles.apply(SpecialOffersTooltipAnchor, 'StyledTooltip');
const SellingPrice = ({ sellingPrice }) => {
    const { t } = useTranslation();
    return (_jsxs(SellingPriceContainer, { children: [_jsx(SellingPriceCopy, { "data-testid": "cy-special-offer-card-selling-price-copy", size: "small", children: _jsx(InlineTextAndTooltip, { text: t('Shared.Common.sellingPriceStartingFromLabel'), children: _jsx(StyledTooltip, { children: t('Shared.Common.msrpStartingFromTooltipLabel') }) }) }), _jsx(PriceWrapper, { children: _jsx(PriceComponent, { prices: {
                        allInPrice: {
                            value: sellingPrice.sellingPrice,
                            label: '',
                        },
                        msrpPrice: {
                            value: sellingPrice.sellingPrice,
                            label: '',
                        },
                        discount: {
                            priceDiscountAmount: sellingPrice.discount,
                            sellingPriceWithDiscount: sellingPrice.discount,
                            msrpWithDiscount: sellingPrice.discount,
                        },
                    }, saveAboveLabel: "", allInPriceTooltipLabel: t('Shared.Common.sellingPriceTooltipLabel'), msrpStartingFromTooltipLabel: t('Shared.Common.msrpStartingFromTooltipLabel'), showSellingPriceDisclaimer: true, frieghtPDIFeesCost: "", dealerFee: "", isFetching: false, hasError: false, errorMessage: t('Pages.Models.Exploration.contactLocalDealerLabel'), horizontalAlignment: "left", alignItems: "left", priceComponentStyles: {
                        priceStyles: {
                            copy: {
                                styles: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    fontSize: ['26px', '34px', '34px'],
                                },
                            },
                            discount: {
                                size: 'small',
                                styles: {
                                    marginLeft: ['0px', '0px', '0px'],
                                    paddingTop: ['xs', 'xs', 'xs'],
                                    textAlign: ['center', 'left', 'left'],
                                },
                            },
                            tooltipContainer: {
                                tooltip: {
                                    display: 'none',
                                },
                            },
                        },
                    }, overrideShowSellingPrice: true, showRebateDisclaimerIndicator: false, suppressDiscount: false }) })] }));
};
export default SellingPrice;
